/* @flow */

import { createReducer } from 'src/shared/core/util/reducerUtils';
import * as braindateTypes from 'src/shared/domain/braindate/action/braindateActionTypes';

/*
 |------------------------------------------------------------------------------
 | Initial State
 |------------------------------------------------------------------------------
 */

const initialState = {
  isBraindateNotFound: false,
};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const setBraindateNotFoundError = (state: Object) => ({
  ...state,
  isBraindateNotFound: true,
});

/*
 |------------------------------------------------------------------------------
 | Reducer
 |------------------------------------------------------------------------------
 */

export default createReducer(initialState, {
  [braindateTypes.FETCH_BRAINDATE_FAILURE]: setBraindateNotFoundError,
});
